module.exports = "../../app/cells/pages/guides/v2_resources/folder.erb";